import styled from "styled-components";

export const FooterContainer = styled.footer`
    background-color: #101522;
    color: #fff;
    font-size: 15px;
`
export const FooterWrap = styled.div`
    padding: 40px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 20px;
    margin: 0 auto;
`